import LogService from './LogService';
import SettingsService from './SettingsService';
import CallerIdService from './CallerIdService';

const logService = new LogService();
const settingsService = new SettingsService();
const callerIdService = new CallerIdService();

export { logService, settingsService, callerIdService };
